// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3K7a6","title":"Header_title__TTLH-","side":"Header_side__3fIuX"};